import axiosMethods from '@/api/apiManager';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleError, consoleLog} from '@/libs/consoleHelper';

import {
  setEnableManualControl,
  setStartManualControl,
  setStopManualControl,
  setRequestPendingManualControl,
  setRecoveryManualControl,
  setCancelManualControl,
} from '../actions/manualControlActions';

import {reqError, reqFailure} from './apiBusiness';

export function PostEnableManualUpdate() {
  return (dispatch) => {
    dispatch(setRequestPendingManualControl(true));
    consoleLog('PostEnableManualUpdate');
    axiosMethods
      .post(APPDATA.API.ENABLE_MANUAL_CONTROL)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setEnableManualControl(response.data));
          dispatch(setRequestPendingManualControl(false));
        } else {
          dispatch(reqFailure(response));
          dispatch(setRequestPendingManualControl(false));
        }
      })
      .catch((error) => {
        dispatch(setRequestPendingManualControl(false));
        dispatch(reqError(error));
      });
  };
}
export function PostStopRecovery() {
  consoleLog('PostStopRecovery');
  return (dispatch) => {
    dispatch(setRequestPendingManualControl(true));
    axiosMethods
      .post(APPDATA.API.STOP_RECOVERY_MANUAL_CONTROL)
      .then((response) => {
        if (response.status === 200) {
          consoleLog('Success Stop Recovery', response);
          dispatch(setRequestPendingManualControl(false));
        } else {
          consoleLog('Fail Stop Recovery', response);
          dispatch(reqFailure(response));
          dispatch(setRequestPendingManualControl(false));
        }
      })
      .catch((error) => {
        dispatch(setRequestPendingManualControl(false));
        dispatch(reqError(error));
      });
  };
}
export function PostStartManualUpdate(param) {
  return (dispatch) => {
    dispatch(setRequestPendingManualControl(true));
    // consoleLog("PostStartManualUpdate");
    axiosMethods
      .post(APPDATA.API.START_MANUAL_CONTROL, param)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setStartManualControl(response.data));
          dispatch(setRequestPendingManualControl(false));
        } else {
          dispatch(reqFailure(response));
          dispatch(setRequestPendingManualControl(false));
        }
      })
      .catch((error) => {
        dispatch(setRequestPendingManualControl(false));
        dispatch(reqError(error));
      });
  };
}

export function PostStopManualUpdate(stopParam, recoveryParam) {
  return (dispatch) => {
    dispatch(setRequestPendingManualControl(true));
    // consoleLog("PostStopManualUpdate");
    axiosMethods
      .post(APPDATA.API.STOP_MANUAL_CONTROL, stopParam)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setStopManualControl(response.data));
          dispatch(setRequestPendingManualControl(false));
          // setTimeout(function () {
          axiosMethods
            .post(APPDATA.API.RECOVERY_MANUAL_CONTROL, recoveryParam)
            .then((response) => {
              if (response.status === 200) {
                dispatch(setRecoveryManualControl(response.data));
                dispatch(setRequestPendingManualControl(false));
              } else {
                dispatch(reqFailure(response));
                dispatch(setRequestPendingManualControl(false));
              }
            })
            .catch((error) => {
              dispatch(setRequestPendingManualControl(false));
              dispatch(reqError(error));
            });
          // }, 1000);
        } else {
          dispatch(reqFailure(response));
          dispatch(setRequestPendingManualControl(false));
        }
      })
      .catch((error) => {
        dispatch(setRequestPendingManualControl(false));
        dispatch(reqError(error));
      });
  };
}

export function PostEnableManualUpdateStartRecovery(recoveryParam) {
  return (dispatch) => {
    dispatch(setRequestPendingManualControl(true));
    // consoleLog("PostStopManualUpdate");
    axiosMethods
      .post(APPDATA.API.ENABLE_MANUAL_CONTROL)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(fetchRequestPendingManualControl(false));
          // setTimeout(function () {
          axiosMethods
            .post(APPDATA.API.RECOVERY_MANUAL_CONTROL, recoveryParam)
            .then((response) => {
              if (response.status === 200) {
                dispatch(setRecoveryManualControl(response.data));
                dispatch(setRequestPendingManualControl(false));
              } else {
                dispatch(reqFailure(response));
                dispatch(setRequestPendingManualControl(false));
              }
            })
            .catch((error) => {
              dispatch(setRequestPendingManualControl(false));
              dispatch(reqError(error));
            });
          // }, 1000);
        } else {
          dispatch(reqFailure(response));
          dispatch(setRequestPendingManualControl(false));
        }
      })
      .catch((error) => {
        dispatch(setRequestPendingManualControl(false));
        dispatch(reqError(error));
      });
  };
}

export function PostRecoveryOfLiquidManual(param) {
  return (dispatch) => {
    dispatch(setRequestPendingManualControl(true));
    consoleLog('PostRecoveryOfLiquidManual', param);
    axiosMethods
      .post(APPDATA.API.RECOVERY_MANUAL_CONTROL, param)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setRecoveryManualControl(response.data));
          dispatch(setRequestPendingManualControl(false));
        } else {
          dispatch(reqFailure(response));
          dispatch(setRequestPendingManualControl(false));
        }
      })
      .catch(() => {
        dispatch(setRequestPendingManualControl(false));
        // Error(dispatch,error)
        consoleError('Failed PostRecoveryOfLiquidManual');
      });
  };
}

export function PostCancelManualControl(param) {
  return (dispatch) => {
    dispatch(setRequestPendingManualControl(true));
    // consoleLog("PostCancelManualControl");
    axiosMethods
      .post(APPDATA.API.CANCEL_MANUAL_CONTROL, param)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setCancelManualControl(response.data));
          dispatch(setRequestPendingManualControl(false));
        } else {
          dispatch(reqFailure(response));
          dispatch(setRequestPendingManualControl(false));
        }
      })
      .catch((error) => {
        dispatch(setRequestPendingManualControl(false));
        dispatch(reqError(error));
      });
  };
}

export function PostStopNormalConcentration(param) {
  return (dispatch) => {
    // consoleLog("PostStopNormalConcentration");
    axiosMethods
      .post(APPDATA.API.POST_STOP_PROTEIN_CONCENTRATOR, param)
      .then((response) => {
        if (response.status === 200) {
          setTimeout(() => {
            axiosMethods
              .post(APPDATA.API.RECOVERY_MANUAL_CONTROL, param)

              .catch((error) => {
                dispatch(reqError(error));
              });
          }, 1100);
        } else {
          dispatch(reqFailure(response));
        }
      })
      .catch((error) => {
        dispatch(reqError(error));
        consoleLog('error', error);
      });
  };
}
